<template lang="pug">
	section.ims
		.title-section Índice de masa corporal
		.slider-content
			.subtitle Peso (kg)
			vue-slider(v-model="w", :marks="marks", :max="200")
				template(v-slot:step="{ label, active }")
					div(:class="['custom-step', { active }]")
		.slider-content
			.subtitle Altura (cm)
			vue-slider(v-model="h", :marks="marks", :max="250")
				template(v-slot:step="{ label, active }")
					div(:class="['custom-step', { active }]")
		.results(:class="{ 'red' : imc <= 18.5, 'green' : imc > 18.5 && imc <= 25, 'yellow' : imc > 25 }")
			.info-result Su índice de masa corporal es:
			.ims-result {{ imc }}
			.ims-status ({{ statusImc }})
			.progress-container
				.actual-progress(:style="leftProgress")
				.progress-results
					.progress-result
						span 18.5
						span 0
					.progress-result
						span 25
					.progress-result
						span 40		
		RecommendProducts(:ids-collections="getCollecionId")
</template>

<script>
import VueSlider from "vue-slider-component";
import RecommendProducts from "@/components/RecommendProducts.vue";
import "vue-slider-component/theme/antd.css";
export default {
  components: {
    VueSlider,
    RecommendProducts
  },
  data() {
    return {
      w: 80,
      h: 180,
      marks: val => val % 50 === 0
    };
  },
  computed: {
    statusImc() {
      if (this.imc < 16) {
        return "Muy bajo peso";
      } else if (this.imc >= 16 && this.imc <= 18.5) {
        return "Bajo peso";
      } else if (this.imc > 18.5 && this.imc <= 25) {
        return "Saludable";
      } else if (this.imc > 25 && this.imc <= 30) {
        return "Sobrepeso";
      } else if (this.imc > 30 && this.imc <= 35) {
        return "Clase obesa I - Obeso moderado";
      } else if (this.imc > 35 && this.imc <= 40) {
        return "Clase obesa II - Muy obeso";
      } else {
        return "Obeso clase III - Muy obeso";
      }
    },
    leftProgress() {
      let p = (this.imc / 40) * 100;
      if (p < 0) {
        p = 0;
      }
      if (p > 99) {
        p = 99;
      }

      return {
        left: p + "%"
      };
    },
    getCollecionId() {
      if (this.imc > 30) {
        return [161859797058, 161859829826, 161859862594];
      } else if (this.imc > 25 && this.imc <= 30) {
        return [161859567682, 161859698754, 161859764290];
      } else if (this.imc > 18.5 && this.imc <= 25) {
        return [161858715714, 161859469378, 161859502146];
      } else if (this.imc >= 16 && this.imc <= 18.5) {
        return [161855930434, 161856192578, 161858650178];
      } else {
        return [161855078466, 161855307842, 161855569986];
      }
    },
    imc() {
      return (this.w / (this.h / 100) ** 2).toFixed(1);
    }
  }
};
</script>
